import { SidebarNavItem, SiteConfig } from "types";
import { env } from "@/env.mjs";

const site_url = env.NEXT_PUBLIC_APP_URL;

export const siteConfig: SiteConfig = {
  name: "Foulware",
  description:
    "Premium DMA cheats and gaming software. Top-tier aimbot, ESP, wallhacks, and more. Undetected. Quick setup. 24/7 support.",
  url: site_url,
  ogImage: `${site_url}/_static/og.jpg?v=2`,
  links: {
    twitter: "https://twitter.com/foulware",
    github: "https://github.com/foulware",
    discord: "https://discord.gg/xvxhT4GkKQ",
  },
};

export const footerLinks: SidebarNavItem[] = [
  {
    title: "Company",
    items: [
      { title: "About", href: "#" },
      { title: "Terms", href: "/terms" },
      { title: "Privacy", href: "/privacy" },
      { title: "Security", href: "/security" },
    ],
  },
  {
    title: "Product",
    items: [
      { title: "Products", href: "/pricing" },
      { title: "Firmware", href: "/firmware" },
      { title: "Guides", href: "/docs" },
      { title: "Dashboard", href: "/dashboard" },
    ],
  },
  {
    title: "Support",
    items: [
      { title: "Discord", href: "https://discord.gg/xvxhT4GkKQ" },
      { title: "Documentation", href: "/docs" },
    ],
  },
];
